var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RefundHeader',{attrs:{"img_header":_vm.header_image,"header":"รับคืนสินค้า","link_back":"refund/refundwaitforprocess"}}),_c('Refund_detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }